import React from 'react';
import { Server, Shield, Cpu } from 'lucide-react';

interface LoadingScreenProps {
  isLoading: boolean;
}

export function LoadingScreen({ isLoading }: LoadingScreenProps) {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-1000 ${
        isLoading
          ? 'opacity-100'
          : 'opacity-0 pointer-events-none backdrop-blur-0'
      }`}
    >
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 animate-gradient">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%239C92AC\' fill-opacity=\'0.10\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            animation: 'pattern-move 20s linear infinite'
          }}
        />
      </div>

      {/* CONTENT */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen w-full backdrop-blur-sm">

        {/* LOGO */}
        <div className="relative mb-12 flex items-center justify-center">
          <div className="absolute inset-0 bg-blue-400/40 rounded-full blur-3xl animate-pulse-slow" />
          <div className="absolute inset-0 bg-white/20 rounded-full blur-xl animate-pulse-fast" />

          <img
            src="/logo-white.png"
            alt="SynthoHosting"
            className="relative w-48 h-auto mx-auto animate-float"
            style={{ filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.3))' }}
          />
        </div>

        {/* TEXT */}
        <div className="space-y-6 text-center">
          <h1
            className="text-5xl font-bold text-white animate-fade-in"
            style={{
              textShadow: '0 2px 10px rgba(0,0,0,0.25)',
              animationDelay: '0.2s'
            }}
          >
            SynthoHosting
          </h1>

          <p
            className="text-xl text-blue-100 animate-fade-in"
            style={{ animationDelay: '0.4s' }}
          >
            Professional Hosting Solutions
          </p>

          {/* ICONS */}
          <div className="flex justify-center gap-12 mt-8">
            <div className="text-white/90 animate-feature-1">
              <Server className="w-6 h-6 mx-auto mb-2 drop-shadow-[0_0_6px_rgba(255,255,255,0.4)]" />
              <span className="text-sm font-medium">High Performance</span>
            </div>

            <div className="text-white/90 animate-feature-2">
              <Shield className="w-6 h-6 mx-auto mb-2 drop-shadow-[0_0_6px_rgba(255,255,255,0.4)]" />
              <span className="text-sm font-medium">DDoS Protection</span>
            </div>

            <div className="text-white/90 animate-feature-3">
              <Cpu className="w-6 h-6 mx-auto mb-2 drop-shadow-[0_0_6px_rgba(255,255,255,0.4)]" />
              <span className="text-sm font-medium">Premium Hardware</span>
            </div>
          </div>
        </div>

        {/* LOADING DOTS */}
        <div
          className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-2 animate-fade-in"
          style={{ animationDelay: '1s' }}
        >
          <div className="w-1.5 h-1.5 bg-white/80 rounded-full animate-loading-dot" />
          <div
            className="w-1.5 h-1.5 bg-white/80 rounded-full animate-loading-dot"
            style={{ animationDelay: '0.2s' }}
          />
          <div
            className="w-1.5 h-1.5 bg-white/80 rounded-full animate-loading-dot"
            style={{ animationDelay: '0.4s' }}
          />
        </div>

      </div>
    </div>
  );
}
